<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">
      <h2 class="titulo">Dashboard Administrativo</h2>

      <!-- KPIs -->
      <div class="kpi-grid">
        <div class="kpi-card" style="--c: var(--brand-primary)">
          <span class="material-icons">assignment</span>
          <div>
            <span class="kpi-num">{{ kpis.totalConsultas }}</span>
            <span class="kpi-lbl">Total consultas</span>
          </div>
        </div>
        <div class="kpi-card" style="--c: var(--brand-accent-sage)">
          <span class="material-icons">people</span>
          <div>
            <span class="kpi-num">{{ kpis.pacientesUnicos }}</span>
            <span class="kpi-lbl">Pacientes únicos</span>
          </div>
        </div>
        <!-- Cambio: "Hoteles activos" → "Aliados activos", ícono hotel → business -->
        <div class="kpi-card" style="--c: #305065">
          <span class="material-icons">business</span>
          <div>
            <span class="kpi-num">{{ kpis.aliadosActivos }}</span>
            <span class="kpi-lbl">Aliados activos</span>
          </div>
        </div>
        <div class="kpi-card" style="--c: #4a7c59">
          <span class="material-icons">cake</span>
          <div>
            <span class="kpi-num">{{ kpis.promedioEdad }}</span>
            <span class="kpi-lbl">Promedio de edad</span>
          </div>
        </div>
        <!-- NUEVO KPI: Idioma más frecuente -->
        <div class="kpi-card" style="--c: #8aab96">
          <span class="material-icons">translate</span>
          <div>
            <span class="kpi-num">{{ kpis.idiomaFrecuente }}</span>
            <span class="kpi-lbl">Idioma más frecuente</span>
          </div>
        </div>
      </div>

      <!-- Fila 1: Consultas por mes + Aliados más visitados -->
      <div class="graficos-fila">
        <div class="grafico-card" style="flex:2">
          <h4 class="grafico-titulo">Consultas por mes</h4>
          <div class="gwrap">
            <Bar :data="chartMeses" :options="optsBar" />
          </div>
        </div>
        <!-- Cambio: "Hoteles más visitados" → "Aliados más visitados" -->
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Aliados más visitados</h4>
          <div class="gwrap">
            <Bar :data="chartAliados" :options="optsHBar" />
          </div>
        </div>
      </div>

      <!-- Fila 2: Género + País + Rangos de edad (se mantiene) -->
      <div class="graficos-fila">
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Distribución por género</h4>
          <div class="gwrap gwrap-dona">
            <Doughnut :data="chartGenero" :options="optsDona" />
          </div>
        </div>
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Top países</h4>
          <div class="gwrap gwrap-dona">
            <Doughnut :data="chartPaises" :options="optsDona" />
          </div>
        </div>
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Rangos de edad</h4>
          <div class="gwrap gwrap-dona">
            <Bar :data="chartEdades" :options="optsBar" />
          </div>
        </div>
      </div>

      <!-- Fila 3: Distribución por idioma + Consultas por doctor -->
      <div class="graficos-fila">
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Distribución por idioma</h4>
          <div class="gwrap gwrap-dona">
            <Doughnut :data="chartIdiomas" :options="optsDona" />
          </div>
        </div>
        <div class="grafico-card" style="flex:2">
          <h4 class="grafico-titulo">Consultas por doctor</h4>
          <div class="gwrap gwrap-hbar">
            <Bar :data="chartDoctores" :options="optsHBar" />
          </div>
        </div>
      </div>

      <!-- NUEVA FILA 4: Distribución por idioma, por mes -->
      <div class="graficos-fila">
        <div class="grafico-card" style="flex:1">
          <div class="grafico-header">
            <h4 class="grafico-titulo">Distribución por idioma (por mes)</h4>
            <div class="idioma-agregar">
              <input v-model.trim="nuevoIdioma" type="text" maxlength="30" placeholder="Agregar idioma…" @keyup.enter="agregarIdioma">
              <button type="button" @click="agregarIdioma" title="Agregar idioma">
                <span class="material-icons">add</span>
              </button>
            </div>
          </div>
          <div class="gwrap gwrap-hbar">
            <Bar :data="chartIdiomasPorMes" :options="optsBarIdiomas" />
          </div>
        </div>
      </div>

      <!-- FILA 5: Métricas de encuesta de satisfacción -->
      <div class="graficos-fila" v-if="encuestas.length">
        <div class="grafico-card" style="flex:1">
          <h4 class="grafico-titulo">Encuestas de satisfacción</h4>
          <div class="encuesta-metricas">
            <div class="encuesta-kpi">
              <span class="encuesta-kpi-num">{{ encuestaMetricas.total }}</span>
              <span class="encuesta-kpi-lbl">Respuestas totales</span>
            </div>
            <div class="encuesta-kpi">
              <span class="encuesta-kpi-num">{{ encuestaMetricas.recomendacion }}</span>
              <span class="encuesta-kpi-lbl">Recomendación prom. (1–5)</span>
            </div>
            <div class="encuesta-kpi" v-for="p in encuestaMetricas.promedios" :key="p.campo">
              <span class="encuesta-kpi-num">{{ p.promedio }}</span>
              <span class="encuesta-kpi-lbl">{{ p.etiqueta }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend, ArcElement,
} from 'chart.js';
import { Bar, Doughnut } from 'vue-chartjs';
import SlideBar from '@/components/SlideBar.vue';
import { getConsultas, getUsuarios, getIdiomas, addIdioma, getConsultasPorIdiomaYMes, getEncuestas } from '@/utils/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const PALETTE = ['#133E68', '#607f70', '#305065', '#8aab96', '#1b6ca8', '#4e9e6f', '#2b4054', '#a8c5a0'];
const MESES_ES = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function contarPor(arr, campo) {
  const c = {};
  arr.forEach(x => { if (x[campo]) c[x[campo]] = (c[x[campo]] || 0) + 1; });
  return c;
}

function top(obj, n = 6) {
  return Object.entries(obj).sort((a, b) => b[1] - a[1]).slice(0, n);
}

export default {
  name: 'DashboardAdmin',
  components: { SlideBar, Bar, Doughnut },
  data() {
    return {
      sidebarCerrado: false,
      consultas: [],
      usuarios: [],
      idiomas: [],
      encuestas: [],
      nuevoIdioma: '',
      porMesIdiomas: [],
      optsBar: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false } },
          y: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 } },
        },
      },
      optsHBar: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: { legend: { display: false } },
        scales: {
          x: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 } },
          y: { grid: { display: false }, ticks: { font: { size: 11 } } },
        },
      },
      optsDona: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 13, padding: 10, font: { size: 11 } } },
        },
      },
      optsBarIdiomas: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom', labels: { boxWidth: 13, padding: 10, font: { size: 11 } } },
        },
        scales: {
          x: { grid: { display: false } },
          y: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 } },
        },
      },
    };
  },
  computed: {
    kpis() {
      const cs = this.consultas;
      const unicos = new Set(cs.map(c => `${c.nombre}_${c.apellido_paterno}`)).size;
      // Cambio: "hotelesActivos" → "aliadosActivos"
      const aliados = new Set(cs.map(c => c.nombre_hotel).filter(Boolean)).size;
      const edades = cs.map(c => Number(c.edad)).filter(e => e > 0);
      const prom = edades.length ? Math.round(edades.reduce((a, b) => a + b, 0) / edades.length) : '—';
      // Calcular idioma más frecuente
      const idiomas = contarPor(cs, 'idioma');
      const masFrecuente = Object.keys(idiomas).length
        ? Object.entries(idiomas).sort((a, b) => b[1] - a[1])[0][0]
        : '—';
      return {
        totalConsultas: cs.length,
        pacientesUnicos: unicos,
        aliadosActivos: aliados,
        promedioEdad: prom,
        idiomaFrecuente: masFrecuente,
      };
    },

    chartMeses() {
      const cs = this.consultas;
      const fechas = cs.map(c => c.fecha?.substring(0, 7)).filter(Boolean);
      const ultimo = [...fechas].sort().pop() || `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
      const [uy, um] = ultimo.split('-').map(Number);
      const meses = [];
      for (let i = 5; i >= 0; i--) {
        let y = uy, m = um - i;
        while (m <= 0) { m += 12; y--; }
        meses.push(`${y}-${String(m).padStart(2, '0')}`);
      }
      return {
        labels: meses.map(k => { const [y, m] = k.split('-'); return `${MESES_ES[+m]} ${y}`; }),
        datasets: [{
          label: 'Consultas',
          data: meses.map(k => cs.filter(c => c.fecha?.startsWith(k)).length),
          backgroundColor: '#133E68',
          borderRadius: 6,
        }],
      };
    },

    // Cambio: chartHoteles → chartAliados
    chartAliados() {
      const pairs = top(contarPor(this.consultas, 'nombre_hotel'));
      return {
        labels: pairs.map(([k]) => k),
        datasets: [{ label: 'Consultas', data: pairs.map(([, v]) => v), backgroundColor: PALETTE }],
      };
    },

    chartGenero() {
      const c = contarPor(this.consultas, 'genero');
      const labels = Object.keys(c);
      return { labels, datasets: [{ data: labels.map(l => c[l]), backgroundColor: PALETTE }] };
    },

    chartPaises() {
      const pairs = top(contarPor(this.consultas, 'pais'), 7);
      const labels = pairs.map(([k]) => k);
      return { labels, datasets: [{ data: pairs.map(([, v]) => v), backgroundColor: PALETTE }] };
    },

    chartEdades() {
      const rangos = [
        { lbl: '0–17',  min: 0,  max: 17  },
        { lbl: '18–30', min: 18, max: 30  },
        { lbl: '31–45', min: 31, max: 45  },
        { lbl: '46–60', min: 46, max: 60  },
        { lbl: '61+',   min: 61, max: 999 },
      ];
      const data = rangos.map(r =>
        this.consultas.filter(c => {
          const e = Number(c.edad);
          return e >= r.min && e <= r.max;
        }).length
      );
      return {
        labels: rangos.map(r => r.lbl),
        datasets: [{ label: 'Pacientes', data, backgroundColor: PALETTE, borderRadius: 5 }],
      };
    },

    chartIdiomas() {
      const c = contarPor(this.consultas, 'idioma');
      const labels = Object.keys(c);
      return { labels, datasets: [{ data: labels.map(l => c[l]), backgroundColor: PALETTE }] };
    },

    encuestaMetricas() {
      const es = this.encuestas;
      const promedio = (campo) => {
        const vals = es.map(e => Number(e[campo])).filter(v => v > 0);
        return vals.length ? (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(1) : '—';
      };
      const campos = [
        { campo: 'tiempo_espera', etiqueta: 'Tiempo de espera' },
        { campo: 'gafete', etiqueta: 'Uso de gafete' },
        { campo: 'presentacion', etiqueta: 'Presentación del médico' },
        { campo: 'atencion_medico', etiqueta: 'Atención médica' },
        { campo: 'claridad_explicacion', etiqueta: 'Claridad de explicación' },
        { campo: 'calidad_precio', etiqueta: 'Calidad-precio' },
        { campo: 'atencion_domedica', etiqueta: 'Atención Domédica' },
      ];
      return {
        total: es.length,
        recomendacion: promedio('recomendacion'),
        promedios: campos.map(c => ({ ...c, promedio: promedio(c.campo) })),
      };
    },

    chartDoctores() {
      const c = {};
      this.consultas.forEach(x => {
        if (!x.id_doctor) return;
        const u = this.usuarios.find(u => String(u.id) === String(x.id_doctor));
        const nombre = u ? (u.nombre_completo || `${u.nombre} ${u.apellido_paterno}`) : `Doctor ${x.id_doctor}`;
        c[nombre] = (c[nombre] || 0) + 1;
      });
      const pairs = top(c, 8);
      return {
        labels: pairs.map(([k]) => k),
        datasets: [{ label: 'Consultas', data: pairs.map(([, v]) => v), backgroundColor: PALETTE }],
      };
    },

    // Distribución por idioma, agrupada por mes (barras), con idiomas gestionables
    chartIdiomasPorMes() {
      const labels = MESES_ES.slice(1);
      const datasets = this.idiomas.map((idioma, i) => ({
        label: idioma,
        data: this.porMesIdiomas.map(m => m[idioma] || 0),
        backgroundColor: PALETTE[i % PALETTE.length],
        borderRadius: 4,
      }));
      return { labels, datasets };
    },
  },
  methods: {
    actualizarSidebar(estado) { this.sidebarCerrado = estado; },
    async cargarDatos() {
      const anio = new Date().getFullYear();
      const [consultas, usuarios, idiomas, encuestas, porMesIdiomas] = await Promise.all([
        getConsultas(),
        getUsuarios(),
        getIdiomas(),
        getEncuestas(),
        getConsultasPorIdiomaYMes(anio),
      ]);
      this.consultas = consultas;
      this.usuarios = usuarios;
      this.idiomas = idiomas;
      this.encuestas = encuestas;
      this.porMesIdiomas = porMesIdiomas;
    },
    async agregarIdioma() {
      if (!this.nuevoIdioma) return;
      this.idiomas = await addIdioma(this.nuevoIdioma);
      this.nuevoIdioma = '';
    },
  },
  mounted() { this.cargarDatos(); },
};
</script>

<style scoped>
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background: var(--brand-beige);
}

.contenido {
  flex-grow: 1;
  padding: 24px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido { margin-left: 80px; }

.titulo {
  font-size: 26px;
  font-weight: 700;
  color: var(--brand-primary);
  margin: 0 0 24px;
}

/* ---------- KPIs ---------- */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.kpi-card {
  background: var(--white);
  border-radius: 14px;
  padding: 18px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 4px 14px rgba(19, 62, 104, 0.08);
  border-left: 4px solid var(--c, var(--brand-primary));
}

.kpi-card .material-icons {
  font-size: 30px;
  color: var(--c, var(--brand-primary));
  opacity: 0.85;
}

.kpi-card > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kpi-num {
  font-size: 26px;
  font-weight: 800;
  color: var(--brand-primary);
  line-height: 1;
}

.kpi-lbl {
  font-size: 11px;
  font-weight: 600;
  color: var(--brand-secondary-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ---------- GRÁFICOS ---------- */
.graficos-fila {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.grafico-card {
  background: var(--white);
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 4px 14px rgba(19, 62, 104, 0.08);
  min-width: 0;
}

.grafico-titulo {
  margin: 0 0 14px;
  font-size: 13px;
  font-weight: 700;
  color: var(--brand-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.grafico-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.grafico-header .grafico-titulo { margin: 0; }

.idioma-agregar {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
}

.idioma-agregar input {
  padding: 6px 10px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  font-size: 12px;
  width: 140px;
}

.idioma-agregar button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  border: 2px solid var(--brand-secondary-light);
  background: var(--white);
  border-radius: 8px;
  color: var(--brand-accent-sage);
  cursor: pointer;
}

.idioma-agregar button:hover {
  border-color: var(--brand-accent-sage);
  background: rgba(96, 127, 112, 0.1);
}

.idioma-agregar .material-icons { font-size: 18px; }

.gwrap       { position: relative; height: 220px; }
.gwrap-dona  { position: relative; height: 230px; }
.gwrap-hbar  { position: relative; height: 250px; }

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1200px) {
  .kpi-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 1024px) {
  .contenido { margin-left: 80px; }
  .graficos-fila { flex-direction: column; }
}

@media (max-width: 768px) {
  .contenido { margin-left: 0 !important; padding: 12px; padding-top: 70px; }
  .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .titulo { font-size: 20px; }
}

@media (max-width: 480px) {
  .kpi-grid { grid-template-columns: 1fr; }
}

/* ---------- MÉTRICAS DE ENCUESTA ---------- */
.encuesta-metricas {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.encuesta-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 14px 18px;
  background: var(--brand-beige);
  border-radius: 10px;
  min-width: 140px;
}

.encuesta-kpi-num {
  font-size: 22px;
  font-weight: 800;
  color: var(--brand-primary);
  line-height: 1;
}

.encuesta-kpi-lbl {
  font-size: 11px;
  color: var(--brand-secondary-light);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 4px;
}
</style>
